import React, { useState } from "react";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import { MdHelpOutline, MdLogout } from "react-icons/md";
import Configurator from "./Configurator";
// import { RiMoonFill, RiSunFill } from 'react-icons/ri';
// import Configurator from './Configurator';
import {
  IoMdNotificationsOutline,
  IoMdInformationCircleOutline,
} from "react-icons/io";
import avatar from "assets/img/avatars/avatar0.png";
import { signOut } from 'firebase/auth';
import { auth } from '@config/firebase';
import { MdBusinessCenter, MdKeyboardArrowDown } from "react-icons/md";
import { useTenant } from '@contexts/TenantContext';
import ConfirmPopup from "components/popup/ConfirmPopup";
import { openNeedAssistanceForm } from '@utils/linkHelpers';

const Navbar = (props: {
  onOpenSidenav: () => void;
  brandText: string;
  secondary?: boolean | string;
  [x: string]: any;
}) => {
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { currentUser, adminSpaces, currentTenant, switchTenant } = useTenant();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      // Use React Router navigate instead of window.location
      navigate('/auth/sign-in/default');
    } catch (error) {
      console.error('Error signing out:', error);
      // Handle error (e.g., show toast notification)
    }
  };

  const handleSubscriptionManagement = () => {
    openNeedAssistanceForm();
  };

  const handleSpaceSwitch = (tenantId: string) => {
    switchTenant(tenantId);
  };
  const {
    onOpenSidenav,
    brandText,
    mini,
    setMini,
    theme,
    setTheme,
    hovered,
  } = props;
  const [darkmode, setDarkmode] = React.useState(() => {
    const savedMode = localStorage.getItem("darkMode");
    const isDark = savedMode === "true";

    // Apply the saved preference immediately
    if (isDark) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }

    return isDark;
  });
  return (
    <nav
      className={`duration-175 linear fixed top-3 right-3 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/30 transition-all ${mini === false
        ? "w-[calc(100vw_-_6%)] md:w-[calc(100vw_-_8%)] lg:w-[calc(100vw_-_6%)] xl:w-[calc(100vw_-_350px)] 2xl:w-[calc(100vw_-_365px)]"
        : mini === true && hovered === true
          ? "w-[calc(100vw_-_6%)] md:w-[calc(100vw_-_8%)] lg:w-[calc(100vw_-_6%)] xl:w-[calc(100vw_-_350px)] 2xl:w-[calc(100vw_-_365px)]"
          : "w-[calc(100vw_-_6%)] md:w-[calc(100vw_-_8%)] lg:w-[calc(100vw_-_6%)] xl:w-[calc(100vw_-_180px)] 2xl:w-[calc(100vw_-_195px)]"
        }  p-2 backdrop-blur-xl dark:bg-[#0b14374d] md:top-4 md:right-[30px] xl:top-[20px]`}
    >
      <div className="ml-[6px]">
        <div className="h-6 w-auto pt-1">
          <a
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            href=" "
          >
            Pages
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span>
          </a>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white whitespace-nowrap"
            to="#"
          >
            {brandText}
          </Link>
        </div>
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white whitespace-nowrap">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-between gap-1 rounded-full bg-white px-3 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[520px] md:flex-grow-0 md:gap-0.5 xl:w-[640px] xl:gap-1">
        <div className="flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[225px]">
          <p className="pl-3 pr-2 text-xl">
            <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
          </p>
          <input
            type="text"
            placeholder="Search..."
            className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
          />
        </div>
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden "
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>
        {/* Space Switcher Dropdown */}
        {adminSpaces.length > 0 && (
          <Dropdown
            button={
              <div className="flex items-center gap-2 cursor-pointer px-3 py-2 rounded-lg hover:bg-gray-100 dark:hover:bg-navy-700 transition-colors">
                <MdBusinessCenter className="h-4 w-4 text-gray-600 dark:text-white" />
                <span className="text-sm font-medium text-navy-700 dark:text-white max-w-[120px] truncate">
                  {currentTenant?.title || 'Loading...'}
                </span>
                <MdKeyboardArrowDown className="h-4 w-4 text-gray-600 dark:text-white" />
              </div>
            }
            animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
            children={
              <div className="flex w-[320px] flex-col gap-2 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
                <div className="flex items-center justify-between mb-3">
                  <p className="text-base font-bold text-navy-700 dark:text-white">
                    Admin Spaces
                  </p>
                  <span className="text-xs text-gray-500 dark:text-gray-400">
                    {adminSpaces.length} {adminSpaces.length === 1 ? 'space' : 'spaces'}
                  </span>
                </div>

                <div className="space-y-2">
                  {adminSpaces.map((space) => (
                    <div
                      key={space.id}
                      onClick={() => handleSpaceSwitch(space.id)}
                      className={`flex items-center justify-between p-3 rounded-lg cursor-pointer transition-colors hover:bg-gray-50 dark:hover:bg-navy-600 ${currentTenant?.id === space.id
                        ? 'bg-brand-50 dark:bg-brand-900/20 border border-brand-500'
                        : 'border border-transparent'
                        }`}
                    >
                      <div className="flex-1">
                        <p className="text-sm font-semibold text-navy-700 dark:text-white">
                          {space.title}
                        </p>
                        <div className="flex items-center gap-2 mt-1">
                          <span className="text-xs text-gray-500 dark:text-gray-400">
                            {space.role}
                          </span>
                          <span className="text-xs text-gray-400">•</span>
                          <span className="text-xs text-gray-500 dark:text-gray-400">
                            {space.users.length} {space.users.length === 1 ? 'user' : 'users'}
                          </span>
                          <span className="text-xs text-gray-400">•</span>
                          <span className="text-xs text-gray-500 dark:text-gray-400">
                            {space.userLimit} limit
                          </span>
                        </div>
                      </div>
                      {currentTenant?.id === space.id && (
                        <div className="w-2 h-2 bg-brand-500 rounded-full"></div>
                      )}
                    </div>
                  ))}
                </div>

                {adminSpaces.length === 0 && (
                  <div className="text-center py-4">
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                      No admin spaces found
                    </p>
                  </div>
                )}
              </div>
            }
            classNames={"py-2 top-4 -left-[180px] md:-left-[250px] w-max"}
          />
        )}
        {/* start Notification */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdNotificationsOutline className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="flex w-[360px] flex-col gap-3 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px]">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-lg font-bold text-navy-700 dark:text-white">
                  Notifications (Coming Soon)
                </h3>
              </div>

              {/* Notification Entries */}
              <div className="space-y-3">
                <div className="flex items-start gap-3 p-3 border-l-4 border-green-500 bg-green-50 dark:bg-green-900/20 rounded-r-lg">
                  <div className="flex-1">
                    <div className="flex items-center justify-between">
                      <p className="text-sm font-semibold text-navy-700 dark:text-white">Coming Soon</p>
                      <span className="text-xs text-gray-500">5 min ago</span>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col items-center justify-center py-6 text-center border-t border-gray-200 dark:border-gray-600 mt-4 pt-4">
                  <p className="text-sm text-gray-600 dark:text-gray-300 mb-1">
                    This feature is currently under development
                  </p>
                </div>
              </div>
            </div>
          }
          classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
        />
        {/* start Horizon PRO */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdInformationCircleOutline className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          children={
            <div className="flex w-[400px] flex-col gap-2 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none max-h-[500px] overflow-y-auto">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-lg font-bold text-navy-700 dark:text-white">
                  Admin Action Log (Coming Soon)
                </h3>
              </div>

              {/* Notification Entries */}
              <div className="space-y-3">
                <div className="flex items-start gap-3 p-3 border-l-4 border-green-500 bg-green-50 dark:bg-green-900/20 rounded-r-lg">
                  <div className="flex-1">
                    <div className="flex items-center justify-between">
                      <p className="text-sm font-semibold text-navy-700 dark:text-white">Coming Soon</p>
                      <span className="text-xs text-gray-500">5 min ago</span>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col items-center justify-center py-6 text-center border-t border-gray-200 dark:border-gray-600 mt-4 pt-4">
                  <p className="text-sm text-gray-600 dark:text-gray-300 mb-1">
                    This feature is currently under development
                  </p>
                </div>
              </div>
            </div>
          }
          classNames={"py-2 top-6 -left-[250px] md:-left-[330px] w-max"}
          animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
        />
        {/* <div
          className="cursor-pointer text-gray-600"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove('dark');
              setDarkmode(false);
            } else {
              document.body.classList.add('dark');
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div> */}
        {/* Subscription Management Button */}
        <button
          onClick={handleSubscriptionManagement}
          className="cursor-pointer"
          title="Manage Subscription"
        >
          <MdHelpOutline className="h-4 w-4 text-gray-600 dark:text-white" />
        </button>

        {/* Settings/Configurator */}
        <Configurator
          theme={theme}
          setTheme={setTheme}
          darkmode={darkmode}
          setDarkmode={setDarkmode}
          setMini={setMini}
        />

        {/* Logout Button */}
        <button
          onClick={() => setShowLogoutConfirm(true)}
          className="cursor-pointer"
          title="Logout"
        >
          <MdLogout className="h-4 w-4 text-gray-600 dark:text-white" />
        </button>

        {/* Profile Avatar */}
        <div className="flex items-center justify-center h-9 w-9">
          <img
            className="h-8 w-8 rounded-full"
            src={avatar}
            alt="Profile"
          />
        </div>
      </div>

      {/* Logout Confirmation Popup */}
      <ConfirmPopup
        isOpen={showLogoutConfirm}
        onClose={() => setShowLogoutConfirm(false)}
        onConfirm={handleLogout}
        title="Confirm Logout"
        message="Are you sure you want to logout?"
        confirmText="Logout"
        cancelText="Cancel"
        variant="danger"
      />
    </nav>
  );
};

export default Navbar;
